"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessTokenAdapter = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const core_bentley_1 = require("@itwin/core-bentley");
const core_common_1 = require("@itwin/core-common");
class AccessTokenAdapter {
    static toAuthorization(accessToken) {
        const splitAccessToken = accessToken.split(" ");
        if (splitAccessToken.length !== 2)
            throw new core_common_1.IModelError(core_bentley_1.RepositoryStatus.InvalidRequest, "Unsupported access token format");
        return {
            scheme: splitAccessToken[0],
            token: splitAccessToken[1]
        };
    }
    static toAuthorizationCallback(accessToken) {
        const authorization = AccessTokenAdapter.toAuthorization(accessToken);
        return async () => authorization;
    }
}
exports.AccessTokenAdapter = AccessTokenAdapter;
//# sourceMappingURL=AccessTokenAdapter.js.map